/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
import { extend } from '../extend/index.js';
import pay$1 from './cn/index.js';
import pay$2 from './cnStation/index.js';
import pay$3 from './tb/index.js';
import pay$4 from './nebula/index.js';
import pay$5 from './dingTalk/index.js';
import '../../tslib.es6-e01eabb2.js';
import '../env/index.js';
import '../../index-f24a9ec1.js';
import '../../index-892d8eee.js';
import '../extend/register/index.js';
import '../../bridges/dd/index.js';
import '../../index-6f6b9acc.js';
import '../../_commonjsHelpers-56d33373.js';
import '../../loadscripts-cf212b8d.js';
import '../../constants-163bd007.js';
import '../../bridge-adpter-api-0316c034.js';
import '../../bridges/windvane/index.js';
import '../../bridges/nebula/index.js';
import '../../index.es-142c5680.js';
import '../../bridges/pangu-mini-app/index.js';
import '../../log-aabf3a34.js';

var apiConfig = {
    web: {
        windvane: {
            cn: pay$1,
            cnStation: pay$2,
            tb: pay$3,
        },
        nebula: pay$4,
        dingTalk: pay$5,
    },
};
var extendPay = extend(apiConfig);
// errorCode=9000代表支付成功，errorCode=6001代表用户手动取消
/**
 * 支付
 * pay返回参数不一致，各端统一promise返回，需要再判断一层。这部分暂时用户决定。
 * @[Experimental("实验性功能，线上环境请做好回归测试")]
 * @param payOption 支付参数
 * @returns
 */
var pay = function (payOption) {
    if (typeof payOption === 'string') {
        return extendPay({ payStr: payOption });
    }
    return extendPay(payOption);
};

export { pay };
